// "2027-06" -> "Jun 2027"
export const formatExpectedCompletion = value => {
  const match = /^(\d{4})-(\d{2})$/.exec(value ?? "");
  if (!match) return value || null;
  return new Date(Number(match[1]), Number(match[2]) - 1, 1).toLocaleDateString(
    "en-US",
    { month: "short", year: "numeric" }
  );
};

// "Under development", plus the expected completion when there is one
export const underDevelopmentLabel = expectedCompletion => {
  const expected = formatExpectedCompletion(expectedCompletion);
  return expected
    ? `Under development · Expected ${expected}`
    : "Under development";
};
